module.exports = __webpack_public_path__ + "img/UTFREM-11.2671e2b6.jpg";